import { put, call } from 'redux-saga/effects';
import { groupCreateAPI, groupSearchAPI, groupUpdateAPI, groupUploadAPI } from 'src/api/GroupApi';
import { SEARCH_RECORD_PAGE_LIMIT } from 'src/constants/CommonConstants';
import { headerShowAction } from 'src/containers/header-container/actions/HeaderActions';
import { takeFirstSagaUtil } from 'src/utils/ReduxSagaUtils';
import { buildSearchWithNoCase } from 'src/utils/CommonUtils';
import { GROUP_ACTIONS } from '../actions/GroupActions';
import { toast } from 'react-toastify';

function* search({
    where, currentPage = 0, autopopulate = true, fullTextSearch = true,
} = {}) {
    try {
        
        
        
        
        const {
            data: {
                data,
            },
        } = yield call(groupSearchAPI, {
            where,
            pageLength: SEARCH_RECORD_PAGE_LIMIT,
            currentPage,
            autopopulate,
        });

        yield put({
            type: GROUP_ACTIONS.GROUP_SEARCH_SUCCESS,
            data,
        });

        return data;
    }
    catch (error) {
        console.error('LOG: function*search -> error', error);
        yield put({
            type: GROUP_ACTIONS.GROUP_SEARCH_ERROR,
        });
        return null;
    }
}

function* edit({
    _id,
}) {
    try {
        const {
            data: {
                data: {
                    data,
                },
            },
        } = yield call(groupSearchAPI, {
            where: {
                _id,
            },
            autopopulate: false,
        });

        if (!data || !data[0]) {
            
            yield put(headerShowAction({
                data: 'Unable to Edit, something when wrong',
            }));
        }
        delete data[0].password;
        
        yield put({
            type: GROUP_ACTIONS.GROUP_UPSERT_SUCCESS,
            currentRecord:data[0],
            data: data[0],
        });
    }
    catch (error) {
        console.error('LOG: error', error);

        yield put(headerShowAction({
            data: error.response.data.data,
        }));

        yield put(headerShowAction({
            data: error.response.data.data,
        }));
    }
}

function* insert(payload) {
    try {
        const {
            data: {
                data,
            },
        } = yield call(groupCreateAPI, payload);
        
       
        yield put(headerShowAction({
            data: 'Created',
        })); 
        toast("Group Created")
        
        yield put({
            type: GROUP_ACTIONS.GROUP_UPSERT_SUCCESS,
            data: {
                ...payload,
                _id: data._id,
            },
        });
        yield put({
            type: GROUP_ACTIONS.GROUP_SEARCH
        });
    }
    catch (error) {
        console.error('LOG: upsert error', error);
        yield put(headerShowAction({
            data: error.response.data.data,
        }));

        yield put({
            type: GROUP_ACTIONS.GROUP_UPSERT_ERROR,
        });
    }
}

function* update(groupId, payload) {
    try {
        yield call(groupUpdateAPI, {
            groupId,
            data: payload,
        });

        yield put(headerShowAction({
            data: 'Updated',
        }));
        if(payload.deleted===true){
            toast("Group deleted")
        }
        else{
            toast("Group account updated")
        } 
        
        yield put({
            type: GROUP_ACTIONS.GROUP_SEARCH
        });
    }
    catch (error) {
        console.error('LOG: upsert error', error);
        yield put(headerShowAction({
            data: error.response.data.data,
        }));

        yield put({
            type: GROUP_ACTIONS.GROUP_UPSERT_ERROR,
        });
    }
}

function* upsert({
    _id,
    ...payload
}) {
    if (_id) {
        yield update(_id, payload);
    }
    else {
        yield insert(payload);
    }
}

export default [
    takeFirstSagaUtil(GROUP_ACTIONS.GROUP_SEARCH, search),
    takeFirstSagaUtil(GROUP_ACTIONS.GROUP_UPSERT, upsert),
    takeFirstSagaUtil(GROUP_ACTIONS.GROUP_EDIT, edit),
];
